import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Button, Typography } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import {Box} from '@material-ui/core'

const useStyles = makeStyles(theme => ({

    font:{
        fontSize:'18px'
    },
  image: {
    boxShadow:
      '25px 60px 125px -25px rgba(80,102,144,.1), 16px 40px 75px -40px rgba(0,0,0,.2)',
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

const Cold = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box  className={className} {...rest} marginBottom={2} marginLeft= {2} marginRight={2} marginTop= {2} display="flex" justifyContent="space-evenly" alignItems="center" padding={6} border="1px solid #ccc" borderRadius="4px">
      <Grid
        container
        justify="space-between"
        spacing={4}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <SectionHeader
            title={
              <span>
        ASKION C-line® 
                <br />
                <Typography component="span" variant="inherit" color="primary">
    ColdEye
                </Typography>
              </span>
            }
          
            align="left"
            disableGutter
            titleVariant="h3"

            />
            <ul className = {classes.font}>
                <li>
            	Sample recognition within less than 5 seconds
                </li>

                <li>
Simultaneous identification of several samples in SBS rack (96, 48, 24, etc.) or box format (9x9, 10x10, etc.)



                </li>
                <li>
                Reliable sample recognition at ambient temperatures from +25°C to -150°C.
                </li>
                <li>
                Reads vial bottom code and rack / box barcode (1D/2D).

                </li>
                <li>
                Available as a portable standalone version or as a retrofittable installation solution for the workbench.


                </li>

                <li>
                Integrated analysis software (for portable version).

                </li>

                <li>
                Integrated power supply for up to 5 h (at -150°C, for portable version)

                </li>

                <li>
                enables best possible sample quality, due to minimal temperature changes during the scanning process

                </li>

    
               
            </ul>

            <SectionHeader
            ctaGroup={[
              <Button variant="contained" color="primary" size="large">
                Quickbook
              </Button>,
              <Button variant="outlined" color="primary" size="large">
              Talk to us
              </Button>,
            ]}
            align="left"
            disableGutter
            titleVariant="h3"
          />
        </Grid>
        <Grid
          item
          container
          justify="flex-start"
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <Image
            src="https://onwhicar.sirv.com/premas/main/askion/clineworkbench.png"
            alt="Coldeye"
            className={classes.image}
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

Cold.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Cold;
